import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class TokenClaimsService {

  static readonly PARTICIPANT_CONTEXT_ID: string = 'participant_context_id';
  
  constructor(private oauthService: OAuthService) {}

  /**
   * Decodes the current access token (JWT) without verifying the signature
   * and returns all claims as a plain object.
   */
  getClaims(): Record<string, any> | null {
    const token = this.oauthService.getAccessToken();
    if (!token) {
      return null;
    }
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      const payload = parts[1];
      // Pad base64url string to a valid base64 length
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
      const json = atob(padded);
      return JSON.parse(json);
    } catch {
      console.warn('TokenClaimsService: failed to decode access token');
      return null;
    }
  }

  /**
   * Returns the `participant_context_id` claim from the current access token,
   * or null if the claim is absent or the token is unavailable.
   */
  getParticipantContextId(): string | null {
    return this.getClaims()?.[TokenClaimsService.PARTICIPANT_CONTEXT_ID] ?? null;
  }
}
